import React, { Component } from "react";

import SingleWidthCard from "../post/single-width-card";
import DoubleWidthCard from "../post/double-width-card";

/**
 * Renders the grid/list of case study cards (single and double width).
 */
class BlogList extends Component 
{
    render () 
    {
        var posts = this.props.posts;
        const featuredPosts = this.props.featuredPosts;
        const services = this.props.services;
        const activeSlug = this.props.activeSlug;
        const currentPage = this.props.currentPage;

        var categoryCorrectFeaturedPosts = [];
        if (activeSlug !== "all") {
            featuredPosts.forEach(post => {
                if (post.node.servicesTaxonomy && typeof post.node.servicesTaxonomy !== "undefined")
                {
                    let services = post.node.servicesTaxonomy.nodes;
    
                    services.forEach(service => {
                        if (service.slug === activeSlug)
                            categoryCorrectFeaturedPosts.push(post);
                    });
                }
            });
        } else {
            categoryCorrectFeaturedPosts = featuredPosts;
        }

        // filter the posts to remove any featured posts that are grabbed in the "all posts" selection
        var filteredPosts = posts.filter(function(post) {        
            // returns an array of matches, i.e. [false, false, true, false] etc
            // by checking the featured post and normal post are equal
            var matchesArray = categoryCorrectFeaturedPosts.map((featuredPost, _) => {
                return featuredPost.node.id === post.node.id;
            });

            // returns true if there are no overlaps, i.e. no true in the matchesArray
            return matchesArray.every(result => result === false);
        });

        if (currentPage === 1)
        {
            // the positions for the double width posts
            var positions = [0, 5, 6, 11];
            // loops through and splices in the featured posts in the positions
            for (var i = 0; i < categoryCorrectFeaturedPosts.length; i++)
                filteredPosts.splice(positions[i], 0, categoryCorrectFeaturedPosts[i]);
        }

        return (
            <div className="blog-card-grid">
                { filteredPosts.map(( post, index ) => {
                    // generate a random key to stop <Fade> from caching
                    return (post !== "undefined" && post !== null && categoryCorrectFeaturedPosts.includes(post) && activeSlug === "all" && currentPage === 1)
                        ?
                            <DoubleWidthCard 
                                key={ `blogCard-${index}` } 
                                data={ post } 
                                spotlight={ true } 
                                services = { services } 
                                type="blog" 
                            />
                        :
                            <SingleWidthCard 
                                key={ `blogCard-${index}` } 
                                data={ post } 
                                services = { services } 
                                type="blog" 
                            />
                }) }
            </div>
        );
    }
}

export default BlogList;